<template>
    <div>
      <TopBar />
      <el-container>
        <el-aside width="200px">
          <SideBar />
        </el-aside>
        <el-main>
          <el-row :gutter="20">
            <!-- 视频上传区域 -->
            <el-col :span="16">
              <div class="video-upload">
                <el-button @click="openUploadModal">上传视频</el-button>
                <video v-if="videoUploaded" controls></video>
              </div>
            </el-col>
            <!-- 课堂签到和学生课堂行为 -->
            <el-col :span="8">
              <div class="class-signin">
                <h3>课堂签到</h3>
                <!-- 模拟签到数据 -->
                 <div class="class-signin1">
                    <p class="text">待分析</p>
                 </div>
                 
              </div>
              <div class="student-behavior">
                <h3>学生课堂行为</h3>
                <!-- 模拟学生行为数据 -->
                <div class="class-signin1">
                    <p class="text">待分析</p>
                 </div>
                 
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="charts-row">
            <!-- 课堂互动分布 -->
            <el-col :span="8">
              <h3>课堂互动分布</h3>
              <!-- 模拟互动分布图表 -->
              <div class="class-signin1">
                    <p class="text">待分析</p>
                 </div>

            </el-col>
            <!-- 教师分析图表 -->
            <el-col :span="16">
              <el-tabs v-model="activeTab">
                <el-tab-pane label="教师注意力分析" name="attention">
                  <!-- 模拟注意力分析图表 -->
                  <div class="class-signin1">
                    <p class="text">待分析</p>
                 </div>

                </el-tab-pane>
                <el-tab-pane label="教师授课相关度分析" name="relevance">
                  <!-- 模拟授课相关度分析图表 -->
                  <div class="class-signin1">
                    <p class="text">待分析</p>
                 </div>

                </el-tab-pane>
              </el-tabs>
            </el-col>
          </el-row>
        </el-main>
      </el-container>


      <!-- 视频上传弹窗 -->
        <el-dialog title="导入视频" :visible.sync="uploadDialogVisible">
            <el-form>
            <el-form-item label="视频">
                <el-upload action="/upload" list-type="text">
                <el-button type="primary">选择视频</el-button>
                </el-upload>
            </el-form-item>
            
            <el-form-item label="学院">
                <el-select v-model="college" placeholder="请选择学院">
                <el-option label="学院1" value="1"></el-option>
                <el-option label="学院2" value="2"></el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item label="课堂">
                <el-select v-model="classroom" placeholder="请选择课堂">
                <el-option label="课堂1" value="1"></el-option>
                <el-option label="课堂2" value="2"></el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item label="老师">
                <el-select v-model="teacher" placeholder="请选择老师">
                <el-option label="老师1" value="1"></el-option>
                <el-option label="老师2" value="2"></el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item label="选择功能: ">
                <el-checkbox-group v-model="selectedFunctions">
                <el-checkbox label="课堂签到" name="type"></el-checkbox>
                <el-checkbox label="学生课堂行为" name="type"></el-checkbox>
                <el-checkbox label="课堂互动分布" name="type"></el-checkbox>
                <el-checkbox label="教师注意力分析" name="type"></el-checkbox>
                <el-checkbox label="教师授课相关度分析" name="type"></el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            
            </el-form>
            <div slot="footer">
            <el-button @click="uploadDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitUpload">提交</el-button>
            </div>
        </el-dialog>
    </div>
  
   
  </template>
  
  <script>
  import SideBar from '../components/SideBar.vue';
  import TopBar from '../components/TopBar.vue';
  
  export default {
    name: 'HomePage',
    components: { SideBar, TopBar },
    data() {
      return {
        videoUploaded: false, // 是否上传了视频
        uploadDialogVisible: false, // 控制上传弹窗
        activeTab: 'attention', // 活跃的标签页
        college: null ,// 选择的学院
        classroom: null,
        teacher: null,
        selectedFunctions: [] // 用于存储选中的功能选项
      };
    },
    methods: {
      openUploadModal() {
        this.uploadDialogVisible = true;
      },
      submitUpload() {
      // 模拟提交逻辑
      console.log("学院:", this.college);
      console.log("课堂:", this.classroom);
      console.log("老师:", this.teacher);
      console.log("选中的功能:", this.selectedFunctions);
      this.uploadDialogVisible = false; // 关闭对话框
      this.$router.push({ path: 'ClassAnalyseF' });
    }
    }
  };
  </script>
  
  <style scoped>
  .video-upload {
    border: 1px solid #e4e4e4;
    padding: 20px;
    text-align: center;
    height: 400px;
    background-color: rgb(214, 237, 237);
  }
  .class-signin, .student-behavior, .charts-row {
    margin-top: 20px;
  }
  .class-signin{
    height: 240px;
    /* background-color: pink; */
  }
  .class-signin1{
    height: 120px;
    /* background-color: pink; */
    display: flex;
    align-items: center;    /* 垂直居中 */
    justify-content: center; /* 水平居中 */
  }
  .student-behavior{
    height: 140px;
    /* background-color: lightblue; */
  }
  .text {
    font-weight: bold; /* 字体加粗 */
    font-size: 36px;   /* 字体大小 */
    color: #b2ceed;
    position: center;
  }
  </style>
  